import { render, staticRenderFns } from "./AccessoriesTab.vue?vue&type=template&id=741f5c56"
import script from "./AccessoriesTab.vue?vue&type=script&lang=js"
export * from "./AccessoriesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports